<template>
  <div class="container page">
    <van-nav-bar class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#d7d7d7" @click="back()" />
      </template>
      <template #right>
        <!-- <div class="right" @click="$router.push({ path: '/GameRecord' });">{{ $t('my.task_record') }}</div> -->

      </template>
    </van-nav-bar>
    <div class="record">
      <div class="nLottery_info">
        <img class="nLottery_detail_ico"  @click="$router.push({ path: '/GameRecord' });" src="/img/detail.png" alt="">
        <div class="nLottery_info_txt1">{{ $t('投注进行中') }}</div>
        <div class="nLottery_info_txt2"><span>{{ this.lottery.next_expect }}</span> </div>
        <div>
          <template v-if="time !== null">

            <van-count-down :time="time" @finish="check()"  format="mm:ss"  />
          </template>
        </div>
        <div class="nLottery_info_group">
          <div class="nLottery_info_txt3">{{ this.lottery.next_expect }} {{ $t('投票活动') }}</div>
          <div class="nLottery_info_txt4">{{ $t('历史记录') }}
        <van-icon name="arrow-down" :class="{ up: active, down: !active }"
          @click="active ? active = false : active = true" /></div>
        </div>
      </div>
      <!-- <div class="period">
        <span class="period-number">{{ this.lottery.next_expect }}</span>
        <div class="next-number">
          <template v-if="time !== null">

            <van-count-down :time="time" @finish="check()" />
          </template>
        </div>

      </div> -->
      <!-- <div class="linear-gradient"
        style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));">
      </div> -->
      <!-- <div class="recent">
        <div class="kuaisan-ball left">
          <span class="res-des middle">{{ this.lottery.one }}</span>
          <span class="res-des middle">{{ this.lottery.two }}</span>
        </div>
        <van-icon name="arrow-down" :class="{ up: active, down: !active }"
          @click="active ? active = false : active = true" />
      </div> -->
    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
          <div class="linear-gradient"
            style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));">
          </div>
          <div class="nLottery_info_title">
            <span></span>
            {{ $t('投票选择') }}
          </div>
          <div class="sumValueTwoSides">
            <div class="rectangle large" :class="{ active: choose[v.type] }" v-for="(v, key) in lottery_peilv_list"
              :key="key" @click="choosePlay(v.type, v.name);">
              <div class="wrapper"
                style="text-align: center;display: flex;justify-content: center;align-items: center;padding: 20px 20px;">
                <img style="height:50px;width: 50px;margin-right: 20px;" :src="v.img" alt="">
                <p class="name-text large" style="text-align: center;margin:0;margin-bottom: 10px;">{{ v.name }}</p>
              </div>
            </div>
          </div>

          <div class="activityGroup">
            <div class="activityTitleWrap">
              <!-- <span class="icons1"></span>
          <span class="icons2"></span> -->
              <span class="ac-title">
                {{ $t('认证实时播报') }}
              </span>
              <!-- <span class="icons2"></span>
          <span class="icons1"></span> -->
            </div>
            <div class="box1">
              <vue-seamless-scroll :data="listData" :class-option="classOption" class="chatList">

                <div class="profitCont" v-for="(item, index) in listData" :key="index">
                  <div class="Cont_item_top">
                    <!-- <div class="item_top_left">
                  <img src="/img/heade_icon.png" draggable="false" /><span><span>{{ item[0] }}</span></span>
                </div> -->
                    <div class="item_top_right">{{ item }}</div>
                  </div>
                  <!-- <div class="Cont_item_bott">
                <div class="item_bott_con">
                  <img :src="item[3]" draggable="false" />
                  <div class="profitText">{{ item[1] }}<span class="money"><span>{{ item[2] }}</span></span></div>
                </div>
              </div> -->
                </div>

              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-bar">
        <!-- <div class="bar">
          <div class="left">
            <div class="item" @click="shopping ? shopping = false : shopping = true">
              <van-icon name="cart-o" class="jixuanico" />
              <span class="text">{{ $t("reservation.task_list") }}</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <div><span class="text">{{ $t("reservation.available_balance") }}</span></div>
            <div><span class="text num"><template v-if="isEye">
                  {{ this.userInfo.money }}
                </template>
                <template v-else>*****
                </template>
              </span>
              <span class="text" style="margin-right: 4px;">{{ $t("reservation.unit") }}</span>
              <van-icon name="eye-o" v-if="isEye" @click="isEye = !isEye" />
              <van-icon name="closed-eye" @click="isEye = !isEye" v-else />
            </div>

          </div>
          <div class="right" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div> -->
        <div class="wrapper" :class="{ active: shopping }">
          <div class="item">
            <span class="label">{{ $t('已选择') }} {{ formData.length }} {{ $t('投票') }} {{ this.formData.length * this.money
              }}
              {{ $t('积分') }}</span>
            <!-- <div class="bet-number">{{ this.shopchoose }}</div> -->
            <!-- <van-icon name="arrow-down" :class="{ up: !shopping, down: shopping }"
              @click="shopping ? shopping = false : shopping = true" /> -->
          </div>
          <div class="item" style="justify-content: center;margin-top: 30px;">
            <span class="label">{{ $t("积分") }}:</span>
            <div class="amount-wrapper">
              <van-field class="jifenInp" v-model="money" type="digit" />
            </div>
            <span class="label" style="background: #eee;padding: 10px;border-radius: 50px;color: #999;"
              @click="money = 0">{{ $t('重置') }}</span>
          </div>
          <div class="toupiaoBtn" @click="jiesuan">{{ $t('投票') }}</div>
        </div>

      </div>

      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <div class="head van-hairline--bottom">
            <p class="text">{{ $t("任务单") }}</p>
          </div>
          <ui class="list">
            <li v-for="(v, key) in formData" :key="key" class="lise-item van-hairline--bottom">
              <div class="main">
                <p class="bet-name">{{ v.name }}</p>
                <p class="detail-text">1{{ $t("reservation.note") }}X{{ money }}({{ $t("积分") }})={{ money
                  }}({{ $t("积分") }})</p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear()">{{ $t("清空") }}</van-button>
            <van-button class="item sub-btn" :disabled="isDisabled" type="default" @click="doSub">{{ $t("确认")
              }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')"
          :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
          <div class="wrapper">
            <div class="item">
              <div class="left font-weight">{{ $t("reservation.num") }}</div>
              <div class="right font-weight">{{ $t("reservation.win_num") }}</div>
            </div>
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left"
                  :style="{ 'margin-left': $store.getters.getBaseInfo.close_number == 1 ? '' : '20px' }">
                  <template v-if="$store.getters.getBaseInfo.close_number == 0">
                    <van-image class="res-img" :src="'img/lottery/shaizi/' + v.opencode[0] + '.png?v=3'">
                      <template v-slot:loading>
                        <van-loading type="spinner" />
                      </template>
                    </van-image>
                    <van-image class="res-img" :src="'img/lottery/shaizi/' + v.opencode[1] + '.png?v=3'">
                      <template v-slot:loading>
                        <van-loading type="spinner" />
                      </template>
                    </van-image>
                    <van-image class="res-img" :src="'img/lottery/shaizi/' + v.opencode[2] + '.png?v=3'">
                      <template v-slot:loading>
                        <van-loading type="spinner" />
                      </template>
                    </van-image>
                    <span class="res-des middle">{{ v.opencode[0] + v.opencode[1] + v.opencode[2] }}</span>
                  </template>


                  <span class="res-des middle">{{ v.one }}</span>
                  <span class="res-des middle">{{ v.two }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>
  </div>
</template>

<script>
// var time;
// var count = 0;
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  data() {
    return {
      jiesuanpage: false,
      listData: [],
      choose: {
        "bi": false,
        "sm": false,
        "si": false,
        "do": false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      isEye: true,
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      sum: 0,
      size: "",
      double: "",
      time: null,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      isDisabled: false
    };
  },
  components: {
    vueSeamlessScroll
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - (this.money * this.formData.length) < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          if (this.isDisabled) return
          this.isDisabled = true
          this.$http({
            method: 'post',
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
            this.isDisabled = false
          })
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      else {
        this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
      }

    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]['type']) {
          this.formData.splice(i, 1)
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.formData[j]['name'];
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]['type']) {
            this.formData.splice(i, 1)
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ 'name': name, 'type': type })
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.formData[j]['name'];
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }

    },
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        // time = window.setInterval(() => {
        //   setTimeout(()=>{
        //     count++;
        //     if(count > 5){
        //       clearInterval(time);
        //       count = 0;
        //     }
        //   },0)
        // }, 300)

        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList();
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv() {
      this.$http({
        method: 'get',
        data: { id: this.$route.query.id },
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryList() {
      this.$http({
        method: 'get',
        data: { key: this.$route.query.key },
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo() {
      this.$http({
        method: 'get',
        data: { key: this.$route.query.key },
        url: 'lottery_get_info'
      }).then(res => {
        if (res.code === 200) {
          // if(parseFloat(this.userInfo.money) < parseFloat(res.data.condition)){
          //   this.$toast(this.$t("reservation.contact_admin"));
          //   this.$router.push({path:'/Home'})
          //   return false;
          // }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }
        } else if (res.code === 401) {
          this.$toast({
            message: res.msg,
            duration: 3000
          });
        }
      })

    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {

      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        if (res.code == 200) {
          this.listData = res.data.winners
        }
      })
      this.getUserInfo();
      this.getLotteryInfo();
      this.getLotteryList();
    }
  },
  destroyed() {
    // clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  // color: #d1af6f;
  font-size: 28px;
  border-radius: 10px;
  border: 2px solid #fff;
  line-height: 60px;
}

.record {
  padding-left: 20px;
  padding-right: 20px;
  background-color: #ffffff;
  // box-shadow: 0 2px 2px 0 #cacaca;
  z-index: 1;
}

.record .period {
  display: flex;
  align-items: center;
  padding: 20px 0;
}

.record .period .cover {
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}

.record .period .period-number {
  flex: 1;
  // margin-left: 20px;
  margin-right: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 35px;
  font-weight: 700;
  color: #d1af6f;
}

.van-count-down {
  color: #ffffff;
  font-size: 24px;
  margin-top: 10px;
  // float: right;
  border: 1px solid #eee;
  display: inline-block;
  padding: 10px;
  border-radius: 6px;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #d1af6f;
}

.kuaisan-ball .res-des.middle {
  // width: 20%;
  margin: 0 10px;
  font-size: 35px;
}

.van-icon {
  font-size: 40px;
}

.down {
  transition: all .5s;
  font-size: 28px;
}

.up {
  transform: rotate(180deg);
  transition: all .5s;
  font-size: 28px;
}

.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}

.options-bar {
  display: flex;
  align-items: center;
  height: 100%;
}

.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}

.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}

::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}

.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.sumValueTwoSides {
  display: flex;
  padding: 30px 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.rectangle {
  overflow: hidden;
}

.rectangle.large {
  margin: 0 0 30px 4%;
  width: 44%;
  border-radius: 10px;
  box-shadow: 0 0 8px 0vw #e4e4e7;
}

.rectangle .wrapper {
  position: relative;
  // padding: 0 10px;
  // height: 200px;
  // background: #fff;
}

.wrapperSuccess {
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.rectangle .wrapper .content {
  // position: absolute;
  display: flex;
  // top: 0;
  // left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: auto;
  height: 75%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.rectangle.large .wrapper {
  // padding-bottom: 66%;
}

.rectangle .wrapper .content .name-text.large {
  font-size: 45px;
  font-weight: 400;
}

.rectangle .wrapper .content .name-text {
  color: #7d7c7c;
  font-weight: bolder;
}

.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
}

.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  // height: 100px;
  z-index: 2;
}

.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: #ffffff;
  box-shadow: 0 0 20px 0 #cacaca;
  z-index: 2;
}

.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  font-size: 20px;
}

.bottom-bar .bar .left .item .text {
  font-size: 22px;
  color: #7d7c7c;
}

.jixuanico {
  font-size: 45px;
}

.bottom-bar .bar .left .line {
  width: 2px;
  height: 50px;
  background: #dadada;
}

.bottom-bar .bar .mid {
  margin-left: 10px;
  flex: 1;
  // display: flex;
  // align-items: center;
  // justify-content: flex-end;
}

.bottom-bar .bar .mid .text {
  font-size: 30px;
  font-weight: 500;
  color: #d1af6f;
}

.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff253f;
}

.bottom-bar .bar .right {
  padding: 0 30px;
  margin: 0 30px;
  color: #ffffff;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  font-size: 40px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 50px;
}

.rectangle.active {}

.rectangle.active .wrapper {
  position: relative;
}

.rectangle.active .wrapper::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  content: '';
  height: 100%;
  // background: linear-gradient(90deg, #d1af6f, #d1af6f);
  opacity: 0.5;

}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #d1af6f;
  font-size: 35px;
}

::v-deep .van-popup {
  position: absolute;
}

::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}

::v-deep .van-popup--top {
  top: -1px;
}

.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.wrapper .item .left {
  width: 200px;
  font-size: 24px;
  text-align: center;
  font-weight: 500;
  color: #d1af6f;
}

.font-weight {
  font-weight: 700 !important;
}

.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 24px;
  justify-content: center;
  overflow: hidden;
  color: #d1af6f;
}

.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}

.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.wrapper .item .kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #d1af6f;
}

.wrapper .item .kuaisan-ball .res-des.middle {
  // width: 15%;
  font-size: 24px;
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #ffffff;
  color: #d1af6f;
}

.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  text-align: center;
  color: #d1af6f;
  font-size: 35px;
  font-weight: 500;
}

.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}

.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}

.play-type-tip .wrapper .item .van-icon {
  color: #6950FB;
  font-size: 60px;
}

.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #d1af6f;
  line-height: 0px;
}

.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #d1af6f;
  line-height: 30px;
}

.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}

.rectangle.active .wrapper {
  background-color: #d1af6f !important;
}

.rectangle.active:nth-child(1) .wrapper {
  background-color: #8948fb !important;
}

.rectangle.active:nth-child(2) .wrapper {
  background-color: #ff6398 !important;
}

.rectangle.active:nth-child(3) .wrapper {
  background-color: #2095f2 !important;
}

.rectangle.active:nth-child(4) .wrapper {
  background-color: #ff7d73 !important;
}

.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: #fff !important;
}

.bottom-bar .wrapper {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  // height: 230px;
  background-color: #ffffff;
  z-index: 1;
  box-shadow: 0 0 10px 0 #cacaca;
  transition: transform .3s cubic-bezier(.21, 0, .55, 0);
}

.bottom-bar .wrapper.active {
  transform: translateY(-100%);
  border-radius: 30px 30px 0 0;
}

.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}

.bottom-bar .wrapper .item .label {
  font-size: 30px;
  line-height: 30px;
  color: #d1af6f;
}

.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 16px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ff253f;
  font-size: 30px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}

.bottom-bar .wrapper .item .amount-wrapper {
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.van-cell {
  font-size: 30px;
  line-height: 50px;
}

.bottom-bar .wrapper .item .part {
  margin-right: 20px;
}

.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: #d1af6f;
}

.bottom-bar .wrapper .item .part .number {
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}

::v-deep .van-field__control {
  color: #ff253f;
}

.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #ffffff;
  border-radius: 30px;
}

.confirm-order-modal .head {
  position: relative;
  height: 80px;
}

.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #d1af6f;
}

::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}

.van-popup--center {
  border-radius: 30px;
}

.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}

.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}

.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}

.confirm-order-modal .list .lise-item {
  color: #ff253f;
}

.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}

.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}

.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background-color: #ffffff;
}

.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  color: #ffffff;
  border: 0;
}

.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #d1af6f;
  float: right;
}



.profitCont .Cont_item_top .item_top_left img {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-right: 12px;
}

.profitCont .Cont_item_top .item_top_left {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 30px;
  color: #666;
}

.profitCont .Cont_item_top .item_top_right {
  color: #666;
  font-size: 22px;
}

.profitCont .Cont_item_top {
  display: flex;
  align-items: center;
  padding: 22px 32px;
  background: #fff;
  justify-content: space-between;
}

.profitCont .Cont_item_bott {
  padding: 10px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.profitCont .Cont_item_bott .item_bott_con {
  display: flex;
  align-items: center;
}

.profitCont .Cont_item_bott .item_bott_con img {
  width: 66px;
  height: 66px;
  border-radius: 6px;
  margin-right: 10px;
}

.profitCont .Cont_item_bott .item_bott_con .profitText {
  color: #333;
  font-size: 26px;
}

.profitCont .Cont_item_bott .item_bott_con .profitText .money {
  margin-left: 6px;
  color: #01bccf;
  font-weight: 600;
}


.activityTitleWrap {
  display: flex;
  align-items: center;
  background: #d1af6f;
  text-align: center;
  justify-content: center;
  padding: 34px 26px;
  color: #ffffff;
  border-radius: 20px 20px 0 0;
}

.profitCont:nth-child(2n) .Cont_item_top {
  background: #f0f0f0;
}

.activityTitleWrap .icons1 {
  width: 4px;
  height: 18px;
  border-radius: 2px;
  background: #e6241a;
  margin-right: 4px;
  margin-left: 4px;
  opacity: .5;
}

.activityTitleWrap .icons2 {
  width: 4px;
  height: 30px;
  border-radius: 1px;
  background: #e6241a;
  margin-left: 4px;
  margin-right: 4px;
}

.activityTitleWrap .ac-title {
  color: #ffffff;
  font-size: 24px;
  margin: 0 8px;
  font-weight: 700;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}


.box1 {
  max-height: 500px;
  padding: 10px 0;
  border-radius: 10px;
  // background: linear-gradient(60deg, #765e6e, #c1e2f1);
  overflow: hidden;
}

.jifenInp {
  // width: 50%;
  background: #eee;
  border-radius: 50px;
  margin: 0 10px;
}

.toupiaoBtn {

  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  color: #ffffff;
  border-radius: 10px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px auto 30px;
}

.activityGroup {
  border-radius: 20px;
  margin: 0 30px;
  border: 2px solid #d1af6f;
  padding-bottom: 10px;
}
.nLottery_info{
  background: linear-gradient(270deg, #d1bb6f, #d1af6f);
  border-radius: 20px 20px 0 0;
  padding: 30px;
  color: #ffffff;
  font-size: 24px;
  margin: 20px 0;
  position: relative;
}
.nLottery_info_txt1{
  margin-bottom: 20px;
  
}
.nLottery_info_txt2{
  
  font-size: 26px;
  margin-bottom: 20px;
}
.nLottery_info_txt2 span{
  font-weight: bold;
}
.nLottery_info_txt3{
}
.nLottery_info_txt4{

}
.nLottery_info_group{
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.nLottery_info_title{
  padding-left:30px;
  padding-top: 20px;
  position: relative;
  display: flex;
  // justify-content: center;
  align-items: center;
}
.nLottery_info_title span{
  display: inline-block;
  background: #d1af6f;
  width: 8px;
  height: 30px;
  border-radius: 10px;
  margin-right: 16px;
}
.nLottery_detail_ico{
 position: absolute;
 top: 30px;
 right: 30px;
 width: 40px;
//  height: 60px;
}
</style>
